import Component from '../core/Component'
import { IE, CMS } from '../core/config'
import Scrollbar from 'smooth-scrollbar'
import OverscrollPlugin from 'smooth-scrollbar/plugins/overscroll'

Scrollbar.use(OverscrollPlugin)

export default class SmoothScroller extends Component {
    constructor(element) {
        super(element)
    }

    prepare() {
        if (!IE && !CMS) {
            this.scrollbar = Scrollbar.init(this.element, {
                renderByPixels: true,
                alwaysShowTracks: true
            })
        }
    }

    destroy() {
        if (this.scrollbar) {
            this.scrollbar.destroy(this.element)
            this.element.removeAttribute('data-scrollbar')
        }
    }
}